var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"storefront fill-height",staticStyle:{"width":"100%"}},[(_vm.filterVisible)?_c('WebshopStore'):_c('CampaignsPromotion')],1)}
var staticRenderFns = []

export { render, staticRenderFns }